export const PACKAGE_TYPES = [
  "Carton", "Pallet", "Box", "Crate", "Envelope", "Satchel", "Bag", "Tube", "Drum", "Skid", "Other",
];

const COLOR_TOKENS = [
  { border: "border-orange-600", bg: "bg-orange-600", tint: "bg-orange-50 dark:bg-orange-950" },
  { border: "border-blue-600",   bg: "bg-blue-600",   tint: "bg-blue-50 dark:bg-blue-950" },
  { border: "border-emerald-600", bg: "bg-emerald-600", tint: "bg-emerald-50 dark:bg-emerald-950" },
  { border: "border-violet-600", bg: "bg-violet-600", tint: "bg-violet-50 dark:bg-violet-950" },
  { border: "border-amber-600",  bg: "bg-amber-600",  tint: "bg-amber-50 dark:bg-amber-950" },
  { border: "border-pink-600",   bg: "bg-pink-600",   tint: "bg-pink-50 dark:bg-pink-950" },
];

export const GROUP_OPTIONS = [
  { value: "0", label: "No group" },
  { value: "1", label: "Group 1" },
  { value: "2", label: "Group 2" },
  { value: "3", label: "Group 3" },
  { value: "4", label: "Group 4" },
  { value: "5", label: "Group 5" },
  { value: "6", label: "Group 6" },
];

function _tokens(g) {
  if (g == null || g === "" || g === "0" || g === 0) return null;
  const n = parseInt(g, 10);
  if (!n || n < 1) return null;
  return COLOR_TOKENS[(n - 1) % COLOR_TOKENS.length];
}

export function groupBorder(g) { return _tokens(g)?.border || ""; }
export function groupBg(g)     { return _tokens(g)?.bg || ""; }
export function groupTint(g)   { return _tokens(g)?.tint || ""; }
